import { useState, useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { TextField, Button, Container, Typography, Box, Grid } from "@mui/material";
import axios from '../Axiosinstance';
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Header from "../components/Header";
import FinHeader from "../Finance/Fheader";
import { buttonBackgroundColor } from "../common";

const EditPayment = ({ onClose, installment, index, id, allinstallments  }) => {
    // const location = useLocation();
    // const navigate = useNavigate();
    // console.log(location.state, "location.state ")
    // const { installment, index, id, allinstallments } = location.state || {};

    const [totalWantToPaid, setTotalWantToPaid] = useState(null);
    const [totalRegistrationFee, settotalRegistrationFee] = useState(0);
    const [paymentDetails, setPaymentDetails] = useState(null);


    // Initialize state with required installment data
    const [formData, setFormData] = useState({
        sessionDate: installment?.sessionDate || "",
        amount: installment?.amount || "",
        discountAmount: installment?.discountAmount || 0,
        sequenceNumber: installment?.sequenceNumber || "", // Added sequence number
        type: installment?.type || "CourseFee", // Added type field (default to "CourseFee" if not present)
    });
    console.log(allinstallments, "allinstallments");

    // Errors state to hold error messages for form fields
    const [errors, setErrors] = useState({
        amount: "",
        discountAmount: "",
    });


    useEffect(() => {
        const fetchPaymentInfo = async () => {


            try {
                const response = await axios.get(
                    `registrationadvances/paymentDetails-info/${id}`
                );
                console.log(response.data, "paymentdetails");
                const { lastRegistrationfeedetail } = response.data
                setPaymentDetails(lastRegistrationfeedetail);
                settotalRegistrationFee(response.data.totalregistrationfee);
                setTotalWantToPaid(response.data.totalWanttoPaid || 0);
            } catch (error) {
                console.error('Error fetching payment info:', error);
                alert('Failed to fetch payment info. Please try again.');
            }
        };

        fetchPaymentInfo();
    }, [id]);
    // Handle form input change
    const handleChange = (e) => {
        setFormData({ ...formData, [e.target.name]: e.target.value });
        setErrors({ ...errors, [e.target.name]: "" });
    };

    console.log("lastRegistrationfeedetail", paymentDetails);
    console.log("allinstallmentssize", allinstallments.length);

    const handleSubmit = async (e) => {
        e.preventDefault();


        const newAmount = parseFloat(formData.amount) || 0;
        const remainingFeeLimit = totalRegistrationFee - 50; // Max discount allowed when index is 0
        const remainingRegistrationFee = totalRegistrationFee - (paymentDetails.amount);
        console.log("remainingRegistrationFee", remainingRegistrationFee)

        let validationErrors = {};

        // **Apply both validations only when index is 0**
        if (isNaN(newAmount) || newAmount <= 0) {
            validationErrors.amount = "Amount should be greater than zero.";

        }

        const discountAmount = parseFloat(formData.discountAmount) || 0;

        // if (!formData.discountAmount || formData.discountAmount.toString().trim() === "") {
        //     validationErrors.discountAmount = "Discount Amount is required";

        // }
        if (formData.discountAmount === "" || formData.discountAmount === null) {
            validationErrors.discountAmount = "Discount Amount is required";
        }


        if (index === 0 && installment.type === "RegistrationFee") {
            // Validation: Discount should not exceed totalRegistrationFee - 50
            if (discountAmount > remainingFeeLimit) {
                validationErrors.discountAmount = `For the first installment, discount must be less than or equal to ${remainingFeeLimit}`;

            }

            // Validation: newAmount + discountAmount should not exceed totalRegistrationFee
            if ((newAmount + discountAmount) > totalRegistrationFee) {
                validationErrors.amount = `For the first installment, the total of amount and discount cannot exceed ${totalRegistrationFee}`;

            }
        }
        else if (index === (allinstallments.length - 1) && installment.type === "RegistrationFee") {
            const lastBeforeInstallment = allinstallments[allinstallments.length - 2];

            if ((newAmount + discountAmount) > lastBeforeInstallment.registrationFeeRemaining) {
                validationErrors.amount = "Max limit reached";

            }

        }

        const lastinstallment = allinstallments.length - 1;
        console.log(totalWantToPaid);
        console.log(allinstallments[lastinstallment].amount)
        if (installment.type === "CourseFee") {
            const totalinstallmentlimit = (allinstallments[lastinstallment].amount) + (totalWantToPaid);

            if ((newAmount + discountAmount > totalinstallmentlimit)) {
                validationErrors.amount = "Max limit reached";
                // return;
            }
        }
        // If there are any validation errors, update the errors state and prevent form submission
        if (Object.keys(validationErrors).length > 0) {
            setErrors(validationErrors);
            return;
        }
        console.log("Form Data:", formData);
        console.log("Total Registration Fee:", totalRegistrationFee);
        console.log("Total Want to Paid:", totalWantToPaid);
        console.log("New Amount:", newAmount);
        console.log("New Discount Amount:", discountAmount);
        const url = `registrationadvances/updateCourseFeeDetails`;

        const queryParams = {
            registrationId: id,
            sequenceNumber: formData.sequenceNumber,
            sessionDate: formData.sessionDate,
            newAmount: formData.amount,
            newDiscountAmount: formData.discountAmount,
            type: installment.type,
        };

        try {
            const response = await axios.put(url, null, { params: queryParams });

            if (response.status === 200) {

                toast.success("Payment details updated successfully!");
                setTimeout(() => {
                    onClose();
                }, 1000);
            } else {
                throw new Error(`Error: ${response.statusText}`);
            }
        } catch (error) {
            console.error("Update failed:", error);
            toast.error("Failed to update payment details.");
        }
    };

    const usertype = localStorage.getItem("usertype");


    return (
        <>
        {/* {usertype === '3' || usertype === '4' ? (
            <Header />
          ) : usertype === '6' ? (
            <FinHeader />
          ) : (
            null
          )} */}
        <Container
            // maxWidth="sm"
            // sx={{
            //     border: "1px solid #ccc",  // Adding a border to the container
            //     padding: "20px",            // Padding inside the container
            //     borderRadius: "8px",        // Optional: rounded corners
            //     display: "flex",            // Using flexbox to center the content
            //     flexDirection: "column",    // Align items vertically
            //     justifyContent: "center",   // Center content vertically
            //     alignItems: "center",       // Center content horizontally
            //     marginTop: "50px",          // Adding margin to the top for better view
            //     marginBottom: "50px",       // Optional: Adding margin at the bottom
            // }}
        >
            {/* <Typography variant="h4" gutterBottom>
                Edit Payment
            </Typography>
            <Typography variant="body1" gutterBottom>
                <strong>Installment Index:</strong> {index}
            </Typography> */}
            {/* <Typography variant="body1" gutterBottom>
                <strong>StudentName:</strong> {id}
            </Typography> */}


            <Box component="form" onSubmit={handleSubmit} noValidate sx={{ mt: 2 }}>
                <Grid container spacing={2}>
                    {/* Session Date */}
                    <Grid item xs={12}>
                        <TextField
                            fullWidth
                            label="Session Date"
                            type="date"
                            name="sessionDate"
                            value={formData.sessionDate}
                            onChange={handleChange}
                            InputLabelProps={{ shrink: true }}
                            InputProps={{ readOnly: true }}
                        />
                    </Grid>

                    {/* Amount */}
                    <Grid item xs={12}>
                        <TextField
                            fullWidth
                            label="Amount"
                            type="number"
                            name="amount"
                            value={formData.amount}
                            onChange={handleChange}
                            required
                            error={!!errors.amount}
                            helperText={errors.amount}
                        />
                    </Grid>

                    {/* Discount Amount */}
                    <Grid item xs={12}>
                        <TextField
                            fullWidth
                            label="Discount Amount"
                            type="number"
                            name="discountAmount"
                            value={formData.discountAmount}
                            onChange={handleChange}
                            required  // Marks this field as required
                            // error={formData.discountAmount === ""}  // Adds error styling when the field is empty
                            // helperText={formData.discountAmount === "" ? "Discount Amount is required" : ""}  // Shows a helper text when empty
                            error={!!errors.discountAmount}
                            helperText={errors.discountAmount}
                        />
                    </Grid>

                    {/* Sequence Number (Read-Only) */}
                    <Grid item xs={12}>
                        <TextField
                            fullWidth
                            label="Sequence Number"
                            type="text"
                            name="sequenceNumber"
                            value={formData.sequenceNumber}
                            InputProps={{ readOnly: true }} // Making it non-editable
                        />
                    </Grid>

                    {/* Type (Read-Only) */}
                    <Grid item xs={12}>
                        <TextField
                            fullWidth
                            label="Type"
                            type="text"
                            name="type"
                            value={formData.type}
                            InputProps={{ readOnly: true }} // Making it non-editable
                        />
                    </Grid>

                    {/* Buttons */}
                    <Grid item xs={12} sx={{ display: "flex", justifyContent: "space-between", mt: 2 }}>
                        <Button variant="contained" color="primary" type="submit"   style={{ backgroundColor:buttonBackgroundColor, color:'white' }}>
                            Save Changes
                        </Button>
                        <Button variant="outlined" color="secondary" onClick={onClose}>
                            Cancel
                        </Button>
                    </Grid>
                </Grid>
            </Box>
            {/* <ToastContainer
                position="bottom-right"
                autoClose={5000}
                hideProgressBar
                newestOnTop

            /> */}
        </Container>
        </>
    );
};

export default EditPayment;
